import React from "react"
import {Link} from "react-router-dom"
import {List, ListItem} from "material-ui/List"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {containers} from "@swarm2/core"
import * as Util from "../common"

const RM = Util.intlMessages("rankings")

export function RankingsListRender({rankNames}) {
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text="Rankings" />
        </ToolbarGroup>
      </Toolbar>
      <List>
        {/* TODO: standard league hardcoded. allow league selection */}
        {rankNames.map(name => (
          <ListItem
            key={name}
            primaryText={<RM id={name} />}
            containerElement={<Link to={"/rankings/standard/" + name} />}
          />
        ))}
      </List>
    </div>
  )
}
export default containers.rankings.RankingsList(
  Util.DumpProps(RankingsListRender),
)



// WEBPACK FOOTER //
// ./src/rankings/RankingsList.js